import React, { Component } from "react";
import {
  PageHeader,
  Table,
  Row,
  Tag,
  Input,
  Button,
  Tooltip,
  Modal,
  Select,
} from "antd";
import "../../../style.css";
import withErrorHandler from "../../../hoc/withErrorHandler";
import Axios from "../../../config/axios";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import "../../../style.css";
import "./style.css";
import Loading from "../../../components/Loading";
import searchColumns from "../../../helpers/searchColumns";

const { confirm } = Modal;

class Users extends Component {
  state = {
    users: [],
    searchText: "",
    searchedColumn: "",
    modalVisible: false,
    searchUser: "",
    usersSearced: [],
    units: [],
    subUnits: [],
    form: {
      user_id: "",
      type: "",
      unit_id: "",
      sub_unit: "",
    },
    errors: {},
  };

  componentDidMount() {
    this.fetchUnits();
  }

  fetchUnits = () => {
    Axios.get("/units").then((response) => {
      const units = response.data.payload[0].children;
      this.setState({ units }, () => this.fetchUsers());
    });
  };

  // Prodi options = children of the selected user's unit (form.unit_id).
  getProdiOptions = (unitId = this.state.form.unit_id) => {
    const unit = this.state.units.find(
      (u) => String(u.id) === String(unitId),
    );
    return unit?.children || [];
  };

  fetchUsers = () => {
    const unit = this.state.units.find(
      (unit) => String(unit.id) === String(this.props.user.info.unit_id),
    );

    Axios.get(
      "/users" +
        (this.props.user.info.type === "operator" ? "?type=prodi" : ""),
    ).then(async (response) => {
      let usersUnit = [];
      let subUnit = [];

      if (this.props.user.info.type === "operator") {
        if (unit?.children) {
          unit.children.forEach((e) => {
            subUnit.push(e.id);
          });

          usersUnit = await response.data.payload.filter((user) =>
            subUnit.includes(user.unit_id),
          );
        }
      }

      const selectedUsers =
        this.props.user.info.type === "admin"
          ? response.data.payload
          : usersUnit;
      const users = selectedUsers.map((user) => {
        return Axios.get("/users/api?user_id=" + user.user_id).then((res) => {
          return {
            ...res.data.payload,
            type: user.type,
            _id: user._id,
          };
        });
      });

      Promise.all(users).then((userRes) => {
        this.setState({ users: userRes });
      });
    });
  };

  handleSearchUser = (e) => {
    const user = e.target.value;
    this.setState({ searchUser: user });
    if (user.length >= 3) {
      Axios.get("/users/api?search=" + user).then((response) => {
        this.setState({ usersSearced: response.data.payload });
      });
    } else {
      this.setState({ usersSearced: [] });
    }
  };

  handleSelectedUser = (text, id, unit_id) => {
    let { form } = this.state;
    form.user_id = id;
    form.unit_id = unit_id;
    this.setState({
      searchUser: text,
      form,
      usersSearced: [],
      ...(form.type === "prodi"
        ? { subUnits: this.getProdiOptions(unit_id) }
        : {}),
    });
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  toggleModal = () => {
    this.resetForm();
    this.setState({ modalVisible: !this.state.modalVisible });
  };

  handleChangeForm = (name, value) => {
    let { form } = this.state;
    form[name] = value;

    if (name === "type") {
      if (value === "prodi") {
        this.setState({ subUnits: this.getProdiOptions() });
      } else if (value !== "prodi") {
        this.setState({ subUnits: [] });
      }
    }

    this.setState({ form, errors: {} });
  };

  handleSubmit = () => {
    let { form } = this.state;
    const id = form._id;
    delete form._id;
    if (form.type === "prodi") {
      form.unit_id = form.sub_unit;
      delete form.sub_unit;
    }

    Axios.request({
      method: id ? "PUT" : "POST",
      data: form,
      url: "/users/save" + (id ? "/" + id : ""),
    })
      .then(() => {
        this.toggleModal();
        this.fetchUsers();
        this.resetForm();
      })
      .catch((error) => {
        this.setState({ errors: error.data });
      });
  };

  resetForm = () => {
    const form = {
      user_id: "",
      unit_id: "",
      type: "",
      sub_unit: undefined,
    };
    this.setState({ form, searchUser: "", subUnits: [] });
  };

  handleSelectedTable = (record) => {
    const form = {
      _id: record._id,
      user_id: record.id,
      type: record.type,
      unit_id: record.work_unit_id,
      ...(record.type === "prodi" ? { sub_unit: record.work_unit_id } : {}),
    };
    this.setState(
      {
        form,
        searchUser: record.full_name,
        subUnits:
          record.type === "prodi"
            ? this.getProdiOptions(record.work_unit_id)
            : [],
      },
      this.toggleModal(),
    );
  };

  showConfirmDelete = (record) => {
    confirm({
      title: "Hapus User",
      icon: <ExclamationCircleOutlined />,
      content: "Apakah kamu yakin ingin menhapus " + record.full_name + " ?",
      onOk: () => this.deleteUser(record._id),
      onCancel() {},
    });
  };

  deleteUser = (id) => {
    Axios.delete("/users/delete/" + id).then(() => {
      this.fetchUsers();
    });
  };

  render() {
    const columns = [
      {
        title: "NIP",
        dataIndex: "nip",
        ...searchColumns(
          "nip",
          this.handleSearch,
          this.handleReset,
          this.state.searchedColumn,
          this.state.searchText,
        ),
      },
      {
        title: "Nama",
        dataIndex: "full_name",
        ...searchColumns(
          "full_name",
          this.handleSearch,
          this.handleReset,
          this.state.searchedColumn,
          this.state.searchText,
        ),
      },
      {
        title: "Unit",
        dataIndex: "work_unit",
        ...searchColumns(
          "work_unit",
          this.handleSearch,
          this.handleReset,
          this.state.searchedColumn,
          this.state.searchText,
        ),
      },
      {
        title: "Tipe",
        dataIndex: "type",
        filters: [
          { text: "Admin", value: "admin" },
          { text: "Operator", value: "operator" },
        ],
        filterMultiple: false,
        onFilter: (value, record) => record.type.includes(value),
        render: (type) => {
          const colors = {
            admin: "red",
            operator: "orange",
          };
          return <Tag color={colors[type]}>{type.toUpperCase()}</Tag>;
        },
      },
      {
        title: "",
        render: (record) => (
          <>
            <Tooltip title="Update" className="m-2">
              <Button
                shape="circle"
                type="primary"
                onClick={() => this.handleSelectedTable(record)}
              >
                <EditOutlined />
              </Button>
            </Tooltip>
            <Tooltip title="Delete" className="m-2">
              <Button
                shape="circle"
                type="danger"
                onClick={() => this.showConfirmDelete(record)}
              >
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </>
        ),
      },
    ];

    return (
      <div
        className="site-layout-background"
        style={{ padding: 10, minHeight: 360 }}
      >
        <PageHeader
          className="site-page-header"
          onBack={() => null}
          backIcon={null}
          title="Users"
          subTitle="kelola users"
        />
        <Row style={{ padding: 10 }}>
          <Button
            shape="round"
            style={{ marginBottom: 15 }}
            className="add-button"
            onClick={this.toggleModal}
          >
            <PlusOutlined />
            Tambah User
          </Button>
          <Table
            style={{ width: "100%", overflowX: "auto" }}
            rowKey="_id"
            columns={columns}
            dataSource={this.state.users}
            loading={this.props.loading}
          />
        </Row>

        <Modal
          visible={this.state.modalVisible}
          onCancel={this.toggleModal}
          title="Kelola User"
          onOk={this.handleSubmit}
          okText="Simpan"
          cancelText="Batal"
        >
          <div>
            <label>Cari User</label>
            <Input
              onChange={this.handleSearchUser}
              value={this.state.searchUser}
              placeholder="Cari User"
              disabled={this.state.form._id}
            />
            <div style={{ position: "relative" }}>
              <div className="search-user-list">
                {this.state.usersSearced.map((user) => (
                  <div
                    onClick={() =>
                      this.handleSelectedUser(
                        user.full_name,
                        user.id,
                        user.work_unit_id,
                      )
                    }
                    className="item-list"
                    key={user.id}
                  >
                    {user.nip} - {user.full_name}
                  </div>
                ))}
              </div>
            </div>
            {<span className="error-message">{this.state.errors.user_id}</span>}
          </div>

          {/* <Row  className="mt-10">
                    <label>Unit</label>
                    <Select placeholder="Unit" style={{width:'100%'}} value={this.state.form.unit_id} onChange={(text) => this.handleChangeForm('unit_id', text)}>
                      {
                        this.state.units.map(unit =>
                          <Select.Option key={unit.id} value={unit.id}>{unit.name}</Select.Option>
                        )
                      }
                    </Select>
                    {<span className="error-message">{this.state.errors.unit_id}</span>}
                    </Row> */}
          <Row className="mt-10">
            <label>Tipe User</label>
            <Select
              placeholder="Tipe"
              style={{ width: "100%" }}
              value={this.state.form.type}
              onChange={(text) => this.handleChangeForm("type", text)}
            >
              {this.props.user.info.type === "admin" ? (
                <>
                  <Select.Option value="admin">Admin</Select.Option>
                  <Select.Option value="operator">Operator</Select.Option>{" "}
                  <Select.Option value="guest">GUEST</Select.Option>{" "}
                </>
              ) : null}
              <Select.Option value="prodi">Prodi</Select.Option>
            </Select>
            {<span className="error-message">{this.state.errors.type}</span>}
          </Row>
          <Row>
            {this.state.form.type === "prodi" ? (
              <>
                <Select
                  placeholder="Sub Unit"
                  className="mt-10"
                  style={{ width: "100%" }}
                  value={this.state.form.sub_unit}
                  onChange={(text) => this.handleChangeForm("sub_unit", text)}
                >
                  {this.state.subUnits.map((unit) => (
                    <Select.Option key={unit.id} value={unit.id}>
                      {unit.name} - {unit.level}
                    </Select.Option>
                  ))}
                </Select>
                <span className="error-message">
                  {this.state.errors.unit_id}
                </span>
              </>
            ) : null}
          </Row>
        </Modal>

        <Loading loading={this.props.loading} />
      </div>
    );
  }
}

export default withErrorHandler(Users, Axios);
